import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import "firebase/storage";


const firebaseConfig = {
    apiKey: "AIzaSyBacsQhWCjX8mtJ_8Y_UWdyCY_C7xoMxHQ",
    authDomain: "react-b3733.firebaseapp.com",
    databaseURL: "https://react-b3733.firebaseio.com",
    projectId: "react-b3733",
    storageBucket: "react-b3733.appspot.com",
    messagingSenderId: "960940001511",
    appId: "1:960940001511:web:28a6d319a6c0cd43df3a42",
    measurementId: "G-CJNNB0XDRY"
};

firebase.initializeApp(firebaseConfig);

export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js